import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/styles.css";
import Inicio from "./components/pages/inicio";
import Header from "./components/util/Header";
import EjecucionPresupuestaria from "./components/pages/Transparencia/EjecucionPresupuestaria";
import AvisoObrasWeb from "./components/AvisoObrasWeb";
import Footer from "./components/util/Footer";
import LicenciaConducir from "./components/pages/Tramites/LicenciaConducir";
import ManipuladorAlimentos from "./components/pages/Tramites/ManipuladorAlimentos";
import CalendarioEventos from "./components/pages/CalendarioEventos";
import OficinaEmpleo from "./components/pages/OficinaEmpleo";
import InformacionPublica from "./components/pages/Transparencia/InformacionPublica";
import DeclaracionJurada from "./components/pages/Transparencia/DeclaracionJurada";
import PresupuestoParticipativo from "./components/pages/Transparencia/PresupuestoParticipativo";
import Memoria from "./components/pages/Transparencia/Memoria";
import Oredenanza from "./components/pages/BoletinOFicial/Ordenanza";
import Decretos from "./components/pages/BoletinOFicial/Decretos";
import ResolucionesIndividuales from "./components/pages/BoletinOFicial/ResolucionesIndividuales";
import DefensorVecino from "./components/pages/BoletinOFicial/DefensorVecino";
import Edictos from "./components/pages/BoletinOFicial/Edictos";
import Declaraciones from "./components/pages/BoletinOFicial/Declaraciones";
import ResolucionesGenerales from "./components/pages/BoletinOFicial/ResolucionesGenerales";
import ResolucionesJEM from "./components/pages/BoletinOFicial/ResolucionesJem";
import Historia from "./components/pages/NuestraCiudad/Historia";
import PlanAccionClima from "./components/pages/NuestraCiudad/PlanAccionClima";
import Ejecutivo from "./components/pages/AreaGobierno/Ejecutivo";
import ConcejoDeliberante from "./components/pages/AreaGobierno/ConcejoDeliberante";
import TribunalDeCuenta from "./components/pages/AreaGobierno/TribunalDeCuenta";
import MemoriasTribunal from "./components/pages/AreaGobierno/Tribunal/MemoriasTribunal";
import ResolucionesTribunal from "./components/pages/AreaGobierno/Tribunal/ResolucionesTribunal";
import Organigrama from "./components/pages/AreaGobierno/Organigrama";
import ProyectosPresentados from "./components/pages/ConvencionMunicipal/ProyectosPresentados";
import DespachoComision from "./components/pages/ConvencionMunicipal/DespachoComision";
import ActasSesiones from "./components/pages/ConvencionMunicipal/ActasSesiones";
import Turismo from "./components/pages/Turismo/Turismo";
import LugaresCiudad from "./components/pages/Turismo/LugaresCiudad";
import EventosAnuales from "./components/pages/Turismo/EventosAnuales";
import RecorreOliva from "./components/pages/Turismo/RecorreOliva";
import NavidadGaucha from "./components/pages/Turismo/Eventos/NavidadGaucha";
import Maraton from "./components/pages/Turismo/Eventos/Maraton";
import FiestaAnualDeColectividades from "./components/pages/Turismo/Eventos/FiestaAnualDeColectividades";
import FiestaPatronal from "./components/pages/Turismo/Eventos/FiestaPatronal";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Plazas from "./components/pages/Turismo/Recorre/Plazas";
import PasajesYPaseos from "./components/pages/Turismo/Recorre/PasajesYPaseos";
import Lugares from "./components/pages/Turismo/Recorre/Lugares";
import JardinLechuzas from "./components/pages/Turismo/Recorre/JardinLechuzas";
import Censo from "./components/pages/Censo";
import OficinaTurismo from "./components/pages/Turismo/Destacados/OficinaTurismo";
import TerminalOmnibusPage from "./components/pages/Turismo/Destacados/TerminalOmnibus";
import EstacionTrenes from "./components/pages/Turismo/Destacados/EstacionTrenes";
import MuseoMalvinas from "./components/pages/Turismo/Destacados/MuseoMalvinas";
function App() {
  return (
    <Router>
      <Header />
        <Routes>
          <Route path="/" element={<Inicio/>} />
          <Route path="/Aviso" element={<AvisoObrasWeb/>} />
          <Route path="/transparencia/ejecucion-presupuestaria" element={<EjecucionPresupuestaria/>} />
          <Route path="/tramites/licencia-de-conducir" element={<LicenciaConducir/>} />
          <Route path="/tramites/manipulador-alimentos" element={<ManipuladorAlimentos />} />
          <Route path="/calendario-eventos" element={<CalendarioEventos />} />
          <Route path="/oficina-de-empleo" element={<OficinaEmpleo />} />
          <Route path="/informacion-publica" element={<InformacionPublica />} />
          <Route path="/declaracion-jurada" element={<DeclaracionJurada />} />
          <Route path="/presupuesto-participativo" element={<PresupuestoParticipativo />} />
          <Route path="/memoria-descriptiva" element={<Memoria />} />
          <Route path="/ordenanzas" element={<Oredenanza />} />
          <Route path="/decretos" element={<Decretos />} />
          <Route path="/resoluciones-individuales" element={<ResolucionesIndividuales />} />
          <Route path="/defensor-vecino" element={<DefensorVecino />} />
          <Route path="/edictos" element={<Edictos />} />
          <Route path="/declaraciones" element={<Declaraciones />} />
          <Route path="/resoluciones-generales" element={<ResolucionesGenerales />} />
          <Route path="/resoluciones-junta-electoral-municipal" element={<ResolucionesJEM />} />
          <Route path="/historia" element={<Historia />} />
          <Route path="/plan-local-de-accion-climatica" element={<PlanAccionClima />} />
          <Route path="/ejecutivo" element={<Ejecutivo />} />
          <Route path="/concejo-deliberante" element={<ConcejoDeliberante />} />
          <Route path="/tribunal-de-cuentas" element={<TribunalDeCuenta />} />
          <Route path="/tribunal-de-cuentas/memorias-tribunales" element={<MemoriasTribunal />} />
          <Route path="/tribunal-de-cuentas/resoluciones-tribunal-de-cuenta" element={<ResolucionesTribunal />} />
          <Route path="/organigrama" element={<Organigrama />} />
          <Route path="/proyectos-presentados" element={<ProyectosPresentados />} />
          <Route path="/despacho-comision" element={<DespachoComision />} />
          <Route path="/actas-sesiones" element={<ActasSesiones />} />
          <Route path="/turismo" element={<Turismo />} />
          <Route path="/turismo/lugares-de-la-ciudad" element={<LugaresCiudad />} />
          <Route path="/turismo/recorre-oliva" element={<RecorreOliva />} />
          <Route path="/turismo/eventos-anuales" element={<EventosAnuales />} />
          <Route path="/turismo/oficina-de-turismo" element={<OficinaTurismo />} />
          <Route path="/turismo/terminal-de-omnibus" element={<TerminalOmnibusPage />} />
          <Route path="/turismo/estacion-de-trenes" element={<EstacionTrenes />} />
          <Route path="/turismo/museo-nacional-de-malvinas" element={<MuseoMalvinas />} />
          <Route path="/turismo/eventos-anuales/navidad-gaucha" element={<NavidadGaucha />} />
          <Route path="/turismo/eventos-anuales/maraton" element={<Maraton/>} />
          <Route path="/turismo/eventos-anuales/fiesta-anual-de-colectividades" element={<FiestaAnualDeColectividades />} />
          <Route path="/turismo/eventos-anuales/fiesta-patronal" element={<FiestaPatronal />} />
          <Route path="/plazas" element={<Plazas />} />
          <Route path="/pasajes-y-paseos" element={<PasajesYPaseos />} />
          <Route path="/lugares-para-visitar" element={<Lugares />} />
          <Route path="/censo" element={<Censo />} />
          <Route path="/el-jardin-de-las-lechuzas" element={<JardinLechuzas />} />
        </Routes>
        <Footer />
    </Router>
  );
}

export default App;
